import React from 'react';
import { Coffee, Instagram, Facebook, Twitter, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img 
                src="/images/junto-logo.png" 
                alt="JUNTO®" 
                className="h-36 w-auto object-contain"
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Premium kahve deneyimi için özenle seçilmiş, taze kavrulmuş kahve çekirdekleri. Her yudumda kalite ve lezzet.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-junto-red hover:bg-junto-red-dark rounded-full flex items-center justify-center transition-all hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-junto-red hover:bg-junto-red-dark rounded-full flex items-center justify-center transition-all hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-junto-red hover:bg-junto-red-dark rounded-full flex items-center justify-center transition-all hover:scale-110"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Hızlı Bağlantılar</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-junto-red transition-colors">
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-junto-red transition-colors">
                  Ürünler
                </Link>
              </li>
              <li>
                <Link to="/cart" className="text-gray-300 hover:text-junto-red transition-colors">
                  Sepet
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-junto-red transition-colors">
                  Hakkımızda
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Müşteri Hizmetleri</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-junto-red transition-colors">
                  İletişim
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-gray-300 hover:text-junto-red transition-colors">
                  Sipariş Takibi
                </Link>
              </li>
              <li>
                <Link to="/delivery" className="text-gray-300 hover:text-junto-red transition-colors">
                  Teslimat Koşulları
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-gray-300 hover:text-junto-red transition-colors">
                  İade ve Değişim
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-junto-red transition-colors">
                  Gizlilik & KVKK
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">İletişim</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-junto-red flex-shrink-0 mt-1" />
                <div className="text-gray-300 text-sm space-y-2">
                  <div>
                    <p className="font-semibold text-white">İstanbul</p>
                    <p>Metropol İstanbul 2C/374<br />Ataşehir</p>
                  </div>
                  <div>
                    <p className="font-semibold text-white">Karabük</p>
                    <p>Barış Mah. Özemek Sanayi Sitesi No:8<br />Safranbolu</p>
                  </div>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-junto-red flex-shrink-0" />
                <a href="tel:+905533812134" className="text-gray-300 hover:text-junto-red transition-colors text-sm">
                  0 (553) 381 21 34
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-junto-red flex-shrink-0" />
                <a href="mailto:mehmet@juntokahve.com" className="text-gray-300 hover:text-junto-red transition-colors text-sm">
                  mehmet@juntokahve.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="border-t border-gray-700 pt-8 pb-6">
          <div className="text-center mb-4">
            <h4 className="text-sm font-semibold text-gray-400 mb-4">Güvenli Ödeme Seçenekleri</h4>
            <div className="flex justify-center items-center">
              <img 
                src="/images/payment-methods.png" 
                alt="Ödeme Yöntemleri - Visa, Mastercard, Amex" 
                className="h-12 md:h-16 w-auto object-contain"
              />
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm text-center md:text-left">
              <p className="inline">© 2025 JUNTO® Kahveler. Tüm hakları saklıdır.</p>
              <span className="mx-2 hidden md:inline">|</span>
              <p className="inline mt-2 md:mt-0 block md:inline">Junto, bir KÜME Kahve Sanayi İthalat İhracat Tic. LTD. ŞTİ markasıdır.</p>
            </div>
            <div className="flex space-x-6 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-junto-red transition-colors">
                Gizlilik Politikası
              </Link>
              <Link to="/returns" className="text-gray-400 hover:text-junto-red transition-colors">
                İade ve Değişim
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;